import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
// Mappings between badge's sizes and variants, and design tokens
export const sizeMap = {
    large: {
        fontSize: tokens.fontSizes.medium,
        iconSize: 'small',
        sizing: '22px',
        spacing: '11px',
    },
    medium: {
        fontSize: tokens.fontSizes.small,
        iconSize: 'xsmall',
        sizing: '18px',
        spacing: '9px',
    },
    small: {
        fontSize: tokens.fontSizes.xsmall,
        iconSize: 'tiny',
        sizing: '16px',
        spacing: tokens.spacing.small,
    },
};
const badgeBaseStaticStyle = css({
    alignItems: 'center',
    display: 'inline-flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.bold,
    justifyContent: 'center',
    letterSpacing: '0.5px',
    lineHeight: tokens.lineHeights.tight,
    padding: `0 ${tokens.spacing.xsmall}`,
    textTransform: 'uppercase',
});
const badgeStaticStyle = {
    pill: css({
        borderRadius: '20px',
        padding: `0 ${tokens.spacing.small}`,
    }),
    regular: css({
        borderRadius: tokens.borderRadius.medium,
    }),
    ribbon: css({
        borderRadius: `${tokens.borderRadius.medium} 0 0 ${tokens.borderRadius.medium}`,
        position: 'relative',
    }),
};
export function badgeStyle({ mode, size, type, variant }) {
    const isTransparentGrey = variant === 'greyLight' ||
        variant === 'transparentGrey' ||
        (variant === 'grey' && mode === 'transparent');
    const isTransparentMode = mode === 'transparent' || isTransparentGrey;
    // Set the styles as the default base colors or the specified accent variant
    const variantStyle = variant === 'base' || variant === 'inverse'
        ? {
            main: variant === 'base'
                ? theme.background.contrastInverse
                : theme.background.contrast,
            text: variant === 'base' ? theme.text.main : theme.text.inverse,
            textOnColor: variant === 'base' ? theme.text.inverse : theme.text.main,
            transparent: variant === 'base'
                ? theme.background.transparent
                : theme.background.transparentInverse,
        }
        : theme[isTransparentGrey ? 'grey' : variant];
    return [
        badgeBaseStaticStyle,
        badgeStaticStyle[type],
        css(Object.assign(Object.assign({ backgroundColor: isTransparentGrey
                ? theme.transparentGrey.subtler
                : variantStyle[isTransparentMode ? 'transparent' : 'main'], color: variantStyle[isTransparentMode ? 'transparent' : 'main'], fontSize: sizeMap[size].fontSize, height: type === 'pill'
                ? `calc(${sizeMap[size].sizing} + ${tokens.spacing.xsmall})`
                : sizeMap[size].sizing }, (type === 'ribbon' && {
            marginRight: sizeMap[size].spacing,
        })), { span: {
                color: isTransparentGrey
                    ? theme.transparentGrey.textOnColor
                    : variantStyle[isTransparentMode ? 'text' : 'textOnColor'],
            } })),
    ];
}
export const wrapperStaticStyle = css({
    alignItems: 'center',
    color: 'inherit',
    display: 'inline-flex',
    gap: tokens.spacing.xsmall,
    maxWidth: '164px',
});
export const innerContentStaticStyle = css({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
export const ribbonStaticStyle = css({
    height: 'inherit',
    position: 'absolute',
});
export function ribbonStyle({ size }) {
    return [ribbonStaticStyle, css({ right: `-${sizeMap[size].spacing}` })];
}
